export const formatDuration = seconds => {
  if (!seconds) return "--:--";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
};

export const getVideoResolutionOptions = video => {
  if (!video.resolutions || video.resolutions.length === 0) {
    return [{ label: "Original", url: video.url }];
  }

  return video.resolutions.map(res => ({
    label: `${res.height}p`,
    url: res.url,
    default: res.default
  }));
};

export const getDefaultResolution = video => {
  if (!video.resolutions) return video.url;
  const defaultRes = video.resolutions.find(r => r.default);
  return defaultRes ? defaultRes.url : video.resolutions[0].url;
};
